module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/NextSliderButton/images/next-nav-disabled.7a4594ac.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/NextSliderButton/images/next-nav-disabled.png
// module id = 3151
// module chunks = 11